<template>
    <div class="card" v-if="registrations">

        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.degrees') }}</h3>
                </div>
                <div class="col-6 text-right">
                    <button-radio-group 
                        :options="orderOptions"
                        button-classes="btn-secondary btn-sm"
                        v-model="order"
                        class="d-inline">
                    </button-radio-group>
                </div>
            </div>
        </div>

        <p class="card-body mt-2" v-if="empty">
            <strong>{{ $t('dashboard.no-degree') }}</strong>
        </p>

        <div v-if="!empty">
            
            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="registrations">

                <el-table-column>
                    <template v-slot="{row}">

                        <h3 class="mb-2">
                            <a href="#" @click.prevent="openRegistration(row)" v-if="canReadRegistration(row)">
                                {{ row.degree.name }}
                            </a>
                            <span v-else>{{ row.degree.name }}</span>
                        </h3>

                        <base-progress type="info" :value="progress(row)">
                        </base-progress>

                        <span class="d-block">
                            <strong>{{ progress(row) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                        </span>

                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <span class="d-block mb-1" v-if="row.state.from">
                            <i class="fas fa-calendar-alt mr-1"></i> {{ date(row.state.from) }}
                            <br>to {{ date(row.state.to) }}
                        </span>

                    </template>
                </el-table-column>

                <el-table-column width="100">
                    <template v-slot="{row}">
                        <badge type="secondary" v-if="row.status == 'archived'">
                            {{ $t('status.archived') }}
                        </badge>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" width="90">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" class="ml-1" @click="openRegistration(row)"
                                    v-if="canReadRegistration(row)">
                                {{ $t('dashboard.more') }}
                            </base-button>

                        </div>
                    </template>
                </el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {

            registrations: {
                type: Array,
            }
        },
        
        data() {
            return {
                moment: moment,
                order: 'asc',
            }
        },

        computed: {

            empty() {
                return this.registrations && this.registrations.length == 0
            },

            orderOptions() {
                return [
                    { value: 'asc', label: '<i class="fas fa-arrow-down"></i>' },
                    { value: 'desc', label: '<i class="fas fa-arrow-up"></i>' },
                ]
            }
        },

        watch: {
            order(value) {
                this.registrations.reverse()
            }
        },

        methods: {

            progress(registration) {
                if (registration.state.sessions_count == 0) {
                    return 0
                }
                let progress = (registration.state.completed_sessions ? registration.state.completed_sessions : 0) * 100 / registration.state.sessions_count
                return parseInt(progress)
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            canReadRegistration(registration) {
                return registration.status == 'active'
                    || (registration.status == 'archived' && this.$permissions.hasRight('dashboard.archives.read'))
            },
            
            openRegistration(registration) {
                this.$router.push({
                    name: 'dashboard-cohort-registration',
                    params: {
                        cohortId: this.$route.params.cohortId,
                        registrationId: registration.id
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding: 1.5rem 0 1.5rem 1.5rem;
        font-size: 0.8rem;
    }
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }
    .degrees >>> .progress {
        margin-bottom: 5px;
    }

</style>
